import React from "react";
import styles from "./styles.module.scss";
import theme from "../../../Styles/theme.scss";
import InstallationGoBackButton from "../../InstallationGoBackButton";
import { ArrowCircularRightIcon } from "../../../Styles/Icons/DesignSystem";

const TroubleshootingMethods = ({
  options,
  setHelpChoice,
  closeModal,
  helpChoice,
  isDesktop,
  sensorType,
}) => {
  const optionTitle = (sensorType, key) => {
    if (key === "Factory reset the sensor") {
      return `Factory reset the ${sensorType.toLowerCase()}`;
    } else {
      return key;
    }
  };

  return (
    <div>
      {options.map((option, index) => {
        if (sensorType === "Smart plug" && index === 0) {
          return null;
        } else {
          return (
            <div
              className={`${styles.option} ${
                helpChoice === option.key && styles.selected
              }`}
              key={index}
              onClick={() => setHelpChoice(option.key)}
            >
              <div className={styles.option_left}>
                <div className={styles.option_title}>
                  {sensorType === "Smart plug" ? index : index + 1}.{" "}
                  {optionTitle(sensorType, option?.key)}
                </div>
                <div className={styles.option_body}>{option.value}</div>
              </div>
              <div className={styles.option_right}>
                <ArrowCircularRightIcon colour={theme.primary3} />
              </div>
            </div>
          );
        }
      })}
      {!isDesktop && (
        <InstallationGoBackButton
          label="Go back"
          onClick={closeModal}
          marginTop="24px"
        />
      )}
    </div>
  );
};

export default TroubleshootingMethods;
